import { Locale } from '@wiztime/core';
import {
  DEFAULT_LOCALE,
  isSupportedLocale,
  switchLocale,
  type I18nInstance,
  type SupportedLocale,
} from '@wiztime/i18n';
import { readStorage, writeStorage } from '../lib/safeStorage';
import { StorageKey } from '../lib/storageKeys';
import { logLocalSetting } from '../lib/localSettingLog';

// The translations must cover exactly the locales of the data dictionary (§2).
const localesMatch: [Locale] extends [SupportedLocale]
  ? [SupportedLocale] extends [Locale]
    ? true
    : never
  : never = true;
void localesMatch;

export function loadLocale(): SupportedLocale {
  const stored = readStorage(StorageKey.Locale);
  return isSupportedLocale(stored) ? stored : DEFAULT_LOCALE;
}

/** Switch the UI language (fetching its translation when it is not loaded yet) and remember it on this device. */
export async function applyLocale(i18n: I18nInstance, locale: SupportedLocale): Promise<void> {
  await switchLocale(i18n, locale);
  writeStorage(StorageKey.Locale, locale);
  document.documentElement.lang = locale;
  logLocalSetting(StorageKey.Locale, locale);
}
